const MAX_ERRORS = 50;
const errors = [];

function addError(entry) {
  // Filter sensitive data from error messages
  const sanitizedMessage = entry.message
    ?.replace(/password[=:]\s*\S+/gi, 'password=[FILTERED]')
    ?.replace(/token[=:]\s*\S+/gi, 'token=[FILTERED]')
    ?.replace(/key[=:]\s*\S+/gi, 'key=[FILTERED]') || '';
    
  const sanitizedStack = entry.stack
    ?.replace(/password[=:]\s*\S+/gi, 'password=[FILTERED]')
    ?.replace(/token[=:]\s*\S+/gi, 'token=[FILTERED]') || '';
    
  errors.push({ 
    ...entry, 
    message: sanitizedMessage,
    stack: sanitizedStack,
    time: new Date().toISOString() 
  });
  if (errors.length > MAX_ERRORS) errors.shift();
}

function getErrors() {
  return [...errors];
}

function formatForCopy() {
  const lines = [
    '--- Bug Report ---',
    `URL: ${window.location.href}`,
    `Time: ${new Date().toISOString()}`,
    `Errors (${errors.length}):`,
    '',
  ];
  errors.forEach((e, i) => {
    lines.push(`[${i + 1}] ${e.time} (${e.type})`);
    lines.push(`  ${e.message}`);
    if (e.stack) lines.push(e.stack);
    lines.push('');
  });
  return lines.join('\n');
}

export function initBugReportCapture() {
  window.onerror = (message, source, line, col, err) => {
    addError({
      type: 'error',
      message: err?.message ?? String(message),
      stack: err?.stack ?? `${source}:${line}:${col}`,
    });
  };
  window.onunhandledrejection = (e) => {
    const msg = e.reason?.message ?? e.reason?.toString?.() ?? String(e.reason);
    const stack = e.reason?.stack ?? '';
    addError({ type: 'unhandledrejection', message: msg, stack });
  };
  const orig = console.error;
  console.error = (...args) => {
    orig.apply(console, args);
    addError({
      type: 'console.error',
      message: args.map((a) => (typeof a === 'object' ? JSON.stringify(a) : String(a))).join(' '),
      stack: '',
    });
  };
}

export { getErrors, formatForCopy };
